import type { Special } from "@/types/content";

export const specials: Special[] = [
  {
    id: "s1",
    title: "月夜妖精精选合集",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20moonlit%20fantasy%20collection%20banner%20of%20glowing%20fairies%20gathered%20beneath%20a%20giant%20moon%20in%20a%20misty%20enchanted%20forest%2C%20lanterns%20and%20floating%20light%20particles%2C%20lavender%20and%20deep%20indigo%20palette%2C%20wide%20cinematic%20composition%2C%20high%20detail&width=1200&height=675&seq=fairy-s1-cover&orientation=landscape",
    intro:
      "以月色为主题的妖精影视专题，收录那些关于月光、夜晚与温柔邂逅的故事，带你走进被月辉笼罩的幻想世界。",
    reason:
      "月色是妖精题材最经典的意象，这个合集把「月光」作为情感线索，挑选出氛围感与故事性兼具的作品，适合在安静的夜晚独自品味。",
    filmIds: ["f1", "f8", "f11", "t1", "t3"],
    relatedSpecialIds: ["s2", "s3"],
  },
  {
    id: "s2",
    title: "森林精灵治愈特辑",
    cover:
      "https://readdy.ai/api/search-image?query=Sunlit%20woodland%20fantasy%20collection%20banner%20of%20gentle%20forest%20spirits%20among%20mossy%20ancient%20trees%20and%20wildflowers%2C%20fireflies%20and%20soft%20green%20light%20beams%2C%20fresh%20green%20and%20warm%20beige%20palette%2C%20wide%20cinematic%20composition%2C%20high%20detail&width=1200&height=675&seq=fairy-s2-cover&orientation=landscape",
    intro:
      "森林是妖精的家园，也是疲惫心灵的归处。本专题聚焦治愈系妖精影视，用温柔的叙事抚慰每一颗需要休憩的心。",
    reason:
      "在快节奏的生活里，森林精灵故事提供的松弛感格外珍贵。这个专题收入节奏舒缓、画面温暖的作品，适合疗愈与放松。",
    filmIds: ["f2", "f4", "f6", "f11", "t4", "t9"],
    relatedSpecialIds: ["s1", "s3"],
  },
  {
    id: "s3",
    title: "现代都市精灵物语",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20fantasy%20collection%20banner%20of%20a%20rainy%20neon%20city%20at%20night%20with%20glowing%20fairies%20hidden%20among%20skyscrapers%20and%20alley%20lanterns%2C%20violet%20and%20warm%20orange%20neon%20palette%2C%20wide%20cinematic%20composition%2C%20high%20detail&width=1200&height=675&seq=fairy-s3-cover&orientation=landscape",
    intro:
      "当妖精走进钢筋水泥的都市，会碰撞出怎样的火花？本专题带你认识那些隐居在写字楼、地铁与巷弄之间的现代精灵。",
    reason:
      "把奇幻元素搬进现实都市，是近年来最受欢迎的妖精题材方向。这些作品让幻想照进日常，既有悬念也有温度。",
    filmIds: ["f3", "f9", "f10", "t5", "t7", "t10"],
    relatedSpecialIds: ["s1", "s2"],
  },
];